import React, { useState, useRef, useEffect } from 'react';
import { Stage, Layer, Rect, Line, Text, Transformer, Image } from "react-konva";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import Barcode from 'react-barcode';


const Displaypannel = ({ isTextClicked, konvaImage, heightInInches, widthInInches
    , isRulerChecked, isShowGridChecked, isSnapToGridChecked,textFormatting,fontSize,textColor,setHandleSaveAsPDF,link,codeType    }) => {
    const [position, setPosition] = useState({ x: 50, y: 50 });
    const [textAreas, setTextAreas] = useState([]); // 🟢 Store text fields
    const [isTextMode, setIsTextMode] = useState(false); // 🟢 Toggle text mode
    const [editingId, setEditingId] = useState(null); // 🟢 Track which text is being edited
    const [inputValue, setInputValue] = useState(""); // 🟢 Input value for editing
    const inputRef = useRef(null); // 🟢 Reference for input field
    const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
    const [textBoxes, setTextBoxes] = useState([
        { id: 1, x: 100, y: 100, text: "Label", fontSize: 20, width: 100, height: 30, rotation: 0 }
    ]);
    const [selectedId, setSelectedId] = useState('');
    const [image, setImage] = useState(null);
    const trRef = useRef(null);
    const textRefs = useRef({});
    const imageRef = useRef(null);

    const pixelsPerInch = 96; // Standard DPI
    const miniInchDivisions = 8; // 1/8th inch divisions
    const blockSize = pixelsPerInch / miniInchDivisions;
    const rulerSize = 30; // Space for rulers
    const gridWidth = 600;
    const gridHeight = 400;
    // Calculate stage dimensions based on inches
    const stageWidth = widthInInches * pixelsPerInch + rulerSize * 2;
    const stageHeight = heightInInches * pixelsPerInch + rulerSize * 2;
    const rectRef = useRef(null);
    const transformerRef = useRef(null);
    const transformerImageRef = useRef(null);
    const displayRef = useRef(null);
    const [selectedTextId, setSelectedTextId] = useState(null);
    const gridLines = [];
    const rulerLines = [];
    const rulerLabels = [];
    const baseUrl = link; // URL to be encoded in the QR code
    
    // All use effect hooks should be at the top level of the component
    useEffect(() => {
        if (isTextClicked) {
            setIsTextMode(true); // Enable text mode
        }
    }, [isTextClicked,]); // Re-run effect when isTextClicked changes
    // Focus input when editingId is set
    useEffect(() => {
        if (editingId !== null && inputRef.current) {
            inputRef.current.focus();
        }
    }, [editingId]);
    // 📌 Update Transformer when selection changes
    useEffect(() => {
        debugger
        if (!imageRef.current) return;
        const transformer = imageRef.current;

        if (selectedId === "uploadedImage" && imageRef.current) {
            transformerImageRef.current.node(imageRef.current);
            transformerImageRef.current.getLayer().batchDraw();
        } else {
            transformerImageRef.node();
        }
    }, [selectedId]);
    useEffect(() => {
        if (konvaImage) {
            setImage(konvaImage);

        }
    }, [konvaImage]); // Update the image when a new one is uploaded
   

    useEffect(() => {
        console.log(`Updated Stage Dimensions: ${stageWidth}x${stageHeight}`);
    }, [stageWidth, stageHeight]);
    useEffect(() => {
        console.log(`Updated Stage Dimensions: ${stageWidth}x${stageHeight}`);
    }, [stageWidth, stageHeight, isRulerChecked, isShowGridChecked, isSnapToGridChecked]);
    // Attach Transformer to selected Text
    useEffect(() => {
        if (selectedTextId === null) {
            transformerRef.current.node(); // ✅ Clear all selections
            transformerRef.current.getLayer().batchDraw(); // ✅ Redraw to reflect changes
            return;
        }
        // Check if transformerRef is assigned and valid
        if (!transformerRef.current) return;
        const textNode = textRefs.current[selectedTextId];
        console.log("Text Node:", textNode); // Debugging check
        if (textNode) {
            transformerRef.current.node(textNode);
            transformerRef.current.getLayer().batchDraw();
        } else {
            console.warn("Text node not found for ID:", selectedTextId);
        }
    }, [selectedTextId]);
    useEffect(() => {
        debugger
        setTextAreas((prev) => {
          if (!Array.isArray(prev)) return []; // Ensure it's an array
      
          return prev.map((item) => {
            if (item.id === selectedTextId) {
              return {
                ...item,
                styles: { 
                  ...item.styles, 
                  ...textFormatting,
                  fill: textColor || "#000000", // ✅ Use default if undefined, // ✅ Apply text color change
                },
                fontSize: fontSize, // ✅ Update font size
              };
            }
            console.log("textColor", textColor); // Debugging checks
            return item;
          });
        });
      }, [textFormatting, fontSize, textColor]); // ✅ Trigger update when any of these change
   
     
  // ✅ Pass the function to parent component
  useEffect(() => {
    setHandleSaveAsPDF(() => saveAsPDF); // Store reference without executing
  }, []);

 // All use effect hooks Ends Here
    // Generate grid x lines
    for (let i = rulerSize; i <= stageWidth - rulerSize; i += blockSize) {
        gridLines.push(
            <Line key={`grid-x-${i}`} points={[i, rulerSize, i, stageHeight - rulerSize]} stroke="#ddd" strokeWidth={1} />
        );
    }
    // Generate grid y lines
    for (let i = rulerSize; i <= stageHeight - rulerSize; i += blockSize) {
        gridLines.push(
            <Line key={`grid-y-${i}`} points={[rulerSize, i, stageWidth - rulerSize, i]} stroke="#ddd" strokeWidth={1} />
        );
    }

    // Generate ruler x lines and labels
    for (let i = rulerSize; i <= stageWidth - rulerSize; i += blockSize) {
        let isFullInch = (i - rulerSize) % pixelsPerInch === 0;
        let isHalfInch = (i - rulerSize) % (pixelsPerInch / 2) === 0 && !isFullInch;
        let isQuarterInch = (i - rulerSize) % (pixelsPerInch / 4) === 0 && !isHalfInch && !isFullInch;

        let lineHeight = isFullInch ? rulerSize / 2 : isHalfInch ? 15 : isQuarterInch ? 10 : 5; // ✅ Half inside, half outside
        rulerLines.push(<Line key={`ruler-x-${i}`} points={[i, rulerSize - lineHeight, i, rulerSize + lineHeight]} stroke="gray" strokeWidth={1} />);
        if (isFullInch && i !== rulerSize) {  // ✅ Skip label at (0,0)
            rulerLabels.push(
                <Text
                    key={`ruler-label-x-${i}`}
                    x={i - 6}
                    y={rulerSize - 25}
                    text={`${(i - rulerSize) / pixelsPerInch}"`}
                    fontSize={12}
                    fill="black"
                />
            );
        }
    }

    // Generate ruler y lines and labels
    for (let i = rulerSize; i <= stageHeight - rulerSize; i += blockSize) {
        let isFullInch = (i - rulerSize) % pixelsPerInch === 0;
        let isHalfInch = (i - rulerSize) % (pixelsPerInch / 2) === 0 && !isFullInch;
        let isQuarterInch = (i - rulerSize) % (pixelsPerInch / 4) === 0 && !isHalfInch && !isFullInch;

        let lineWidth = isFullInch ? rulerSize / 2 : isHalfInch ? 15 : isQuarterInch ? 10 : 5; // ✅ Half inside, half outside
        rulerLines.push(<Line key={`ruler-y-${i}`} points={[rulerSize - lineWidth, i, rulerSize + lineWidth, i]} stroke="gray" strokeWidth={1} />);
        if (isFullInch && i !== rulerSize) {  // ✅ Skip label at (0,0)
            rulerLabels.push(
                <Text
                    key={`ruler-label-y-${i}`}
                    x={rulerSize - 25}
                    y={i - 6}
                    text={`${(i - rulerSize) / pixelsPerInch}"`}
                    fontSize={12}
                    fill="black"
                />
            );
        }

    }
    // Handle clicking inside the editor
    const handleEditorClick = (e) => {

        // make it toggle
        if (!isTextMode) return; // ❌ If not in text mode, do nothing

        const stage = e.target.getStage();
        const pointer = stage.getPointerPosition(); // ✅ Get cursor position

        const newTextArea = {
            id: textAreas.length,
            x: pointer.x,
            y: pointer.y,
            text: "",
        };
// ✅ Deselect any selected text

        setTextAreas([...textAreas, newTextArea]);
        setEditingId(newTextArea.id);  // ✅ Immediately enter edit mode
        setInputValue("");  // ✅ Start with empty text
        setIsTextMode(false);  // ✅ Exit text mode after adding

    };


// ✅ Function to Save as PDF
const saveAsPDF = async () => {
    if (!displayRef.current) return;
    
    const canvas = await html2canvas(displayRef.current, { useCORS: true, scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("display_panel.pdf");
  };
    // Handle text click to enter edit mode
    const handleTextClick = (id, text, x, y) => {

        setEditingId(id);
        setInputValue(text);
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 0);
    };
    const handleImageClick = (image) => {
        setSelectedId('uploadedImage'); // Set the selected image ID
        setTimeout(() => {
            if (imageRef.current) {
                imageRef.current.getLayer().batchDraw(); // Update the layer to reflect changes
            }
        }, 0);
    };
    // Handle text input change
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    // Handle saving text on blur or enter key
    const handleInputBlur = () => {
debugger
        setTextAreas(textAreas.map((item) =>
            item.id === editingId ? { ...item, text: inputValue } : item
        ));
        setEditingId(null);
    };
    const handleMouseMove = (e) => {
        const stage = e.target.getStage();
        const pointer = stage.getPointerPosition();

        // Convert to grid coordinates if needed
        setCursorPos({
            x: Math.round((pointer.x - rulerSize) / blockSize) * blockSize,
            y: Math.round((pointer.y - rulerSize) / blockSize) * blockSize,
        });
    };
    // 📌 Handle Image Upload
    const handleImageUpload = (itm) => {
        const file = itm;
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const img = new window.Image();
                img.src = reader.result;
                img.onload = () => {
                    setImage({
                        id: "uploadedImage",
                        x: 200,
                        y: 200,
                        width: img.width / 4,
                        height: img.height / 4,
                        rotation: 0,
                        image: img,
                    });
                };
            };
            reader.readAsDataURL(file);
        }
    };

    // 📌 Handle Image Selection
    const handleImageSelect = () => {
        setTimeout(() => {
            console.log("🔍 Checking imageRef and Transformer...");

            if (!imageRef.current) {
                console.error("🚨 Image reference is NULL! Image is not properly assigned.");
                return;
            }
            if (!trRef.current) {
                console.error("🚨 Transformer reference is NULL! Transformer is not attached.");
                return;
            }

            console.log("✅ Assigning Transformer to Image:", imageRef.current);

            // 🔹 Use setNodes if available, otherwise use nodes
            if (trRef.current.setNodes) {
                trRef.current.setNodes([imageRef.current]);
            } else {
                trRef.current.nodes([imageRef.current]);
            }

            trRef.current.getLayer().batchDraw();
        }, 100); // 🔥 Delay to ensure ref is assigned
    };
    const handleRightClick = (id) => {
        console.log("Right-click on text:", id);
        setSelectedTextId(id); // Set the selected text ID for context menu
        // Open a context menu or show options for formatting (Bold, Italic, etc.)
    };
    
   const generateBarcodes = (start = 1, end = 5) => {
            const barcodes = [];
        if(link === null || link === undefined) return; // No link provided, return empty array
            for (let i = start; i <= end; i++) {
              const url = `${link}${i}`;
              let value = "";
        
              if (codeType === "upc") {
                // Safe numeric hash from URL
                let hash = 0;
                for (let j = 0; j < url.length; j++) {
                  hash = (hash * 31 + url.charCodeAt(j)) >>> 0;
                }
        
                let baseDigits = (hash % 1e11).toString().padStart(11, "0").slice(0, 11);
                const digits = baseDigits.split('').map(d => parseInt(d, 10));
        
                if (digits.length !== 11 || digits.some(isNaN)) {
                  console.error(`Invalid UPC digits generated from URL: ${url}`);
                  continue;
                }
        
                const oddSum = digits.filter((_, idx) => idx % 2 === 0).reduce((sum, d) => sum + d, 0);
                const evenSum = digits.filter((_, idx) => idx % 2 !== 0).reduce((sum, d) => sum + d, 0);
                const total = oddSum * 3 + evenSum;
                const checkDigit = (10 - (total % 10)) % 10;
                value = baseDigits + checkDigit.toString();
              } else {
                // Generate barcode from hash of URL
                let hash = 0;
                for (let j = 0; j < url.length; j++) {
                  hash = (hash * 31 + url.charCodeAt(j)) >>> 0;
                }
                value = hash.toString();
              }
        
              barcodes.push(
                <div key={i} className="mb-4">
                  <p className="mb-2 text-sm text-gray-600">
                    {codeType === 'upc' ? `UPC for: ${url} → ${value}` : `Barcode for: ${url} → ${value}`}
                  </p>
                  <Barcode value={value} format={codeType === 'upc' ? 'UPC' : 'CODE128'} />
                </div>
              );
            }
        
            return barcodes;
          };
        
    //   const upcCode = getValidUPC(url);
    return (
        <>
            <h5 className="text-light mb-3">TEKa Label</h5>
            <div ref={displayRef} className="p-3 border rounded bg-light text-dark">
                {/* <div style={{ width: stageWidth, height: stageHeight }}> */}
                {/* 🔘 Upload Button */}


                <Stage width={stageWidth} height={stageHeight} onClick={handleEditorClick} onMouseMove={handleMouseMove}>
                    {/* onMouseMove={handleMouseMove} */}
                    <Layer>
                        {/* Background */}
                        <Rect width={stageWidth} height={stageHeight} fill="#f0f0f0" />

                        {/* Grid Lines */}
                        {isShowGridChecked && gridLines}


                        {/* Ruler Lines */}
                        {isRulerChecked && (
                            <>
                                {rulerLines}

                                {/* Ruler Labels (Now Outside) */}
                                {rulerLabels}
                            </>
                        )}

                        {/* Rounded Border Inside the Ruler Lines */}
                        <Rect
                            x={rulerSize + 17}
                            y={rulerSize + 17}
                            width={stageWidth - 50}  // 🟢 Dynamically adjust width
                            height={stageHeight - 50} // 🟢 Dynamically adjust height
                            stroke="black"
                            strokeWidth={2}
                            cornerRadius={15}

                            // 🟢 Strong Outer Shadow for 3D Lift
                            shadowColor="rgba(0, 0, 0, 0.6)"
                            shadowBlur={20}
                            shadowOffset={{ x: 8, y: 8 }}
                            shadowOpacity={0.8}

                            fill="transparent"
                        />

                        {/* Draggable Rectangle */}
                        {/* <Rect
                            ref={rectRef}
                            x={position.x + rulerSize}
                            y={position.y + rulerSize}
                            width={100}
                            height={50}
                            fill="blue"
                            draggable
                            onDragEnd={(e) => {
                                setPosition({
                                    x: Math.round((e.target.x() - rulerSize) / blockSize) * blockSize,
                                    y: Math.round((e.target.y() - rulerSize) / blockSize) * blockSize,
                                });
                            }}
                        /> */}
                        {/* 🟢 Render Text Areas */}

                        {textAreas.map((textArea) =>
                            editingId === textArea.id ? null : (
                                <React.Fragment
                                    // key={shape.id || index}
                                    key={textArea.id}
                                >
                                    <Text
                                        key={textArea.id + 1}
                                        ref={(node) => {
                                            if (node) {
                                                textRefs.current[textArea.id] = node;
                                                //console.log("Text ref assigned:", node);
                                            }
                                        }}
                                        x={textArea.x}
                                        y={textArea.y}
                                        text={textArea.text}
                                        fontSize={textArea.fontSize || 16} // ✅ Apply font size
                                        draggable // Ensure dragging is enabled
                                        onMouseDown={(e) => {
                                            if (e.evt.button === 2) { // Right-click
                                                e.evt.preventDefault();
                                                handleRightClick(textArea.id);
                                            }
                                        }}
                                        onClick={(e) => {
                                            if (e.evt.button === 0) { // Left-click
                                                handleTextClick(textArea.id, textArea.text);
                                            }
                                        }}
                                        onDragStart={(e) => {
                                            e.target.moveToTop(); // Ensures dragged element stays above others
                                        }}
                                        onDragEnd={(e) => {
                                            const newX = e.target.x();
                                            const newY = e.target.y();
                                            setTextAreas((prevTextAreas) =>
                                                prevTextAreas.map((item) =>
                                                    item.id === textArea.id
                                                        ? { ...item, x: newX, y: newY }
                                                        : item
                                                )
                                            );
                                        }}
                                        fill={textColor} // ✅ Apply selected text color
                                        fontFamily="Arial" // ✅ Ensure a font that supports bold
                                        fontStyle={textArea.styles?.fontStyle || "normal"} // Apply italic
                                        fontWeight={textArea.styles?.fontWeight === "bold" ? "bold" : "Arial"} // Convert `600` to "bold"
                                        textDecoration={textArea.styles?.textDecoration || "none"} // Apply underline
                                        onContextMenu={(e) => e.evt.preventDefault()} // Prevent default right-click menu
                                    />
                                </React.Fragment>
                            )
                        )}

                        <Transformer ref={transformerRef} rotateEnabled={true} />

                        {/* Render Uploaded Image */}


                        {image && (
                            <Image
                                ref={(node) => {
                                    if (node) {
                                        imageRef.current = node;
                                        //console.log("Text ref assigned:", node);
                                    }
                                }}
                                // ref={imageRef}
                                x={image.x}
                                y={image.y}
                                image={image.image}
                                width={image.width}
                                height={image.height}
                                draggable
                                rotation={image.rotation}
                                onClick={() => handleImageClick(image)} // Add selection logic if needed
                                onTransformEnd={(e) => {
                                    const node = e.target;
                                    setImage({
                                        ...image,
                                        x: node.x(),
                                        y: node.y(),
                                        width: node.width() * node.scaleX(),
                                        height: node.height() * node.scaleY(),
                                        rotation: node.rotation(),
                                    });
                                    node.scaleX(1);
                                    node.scaleY(1);
                                }}
                            />
                        )}
                        <Transformer ref={transformerImageRef} rotateEnabled={true} />
                    </Layer>
                </Stage>
                {/* 🟢 Input box for text editing */}
                {editingId !== null && (
                    <input
                        ref={inputRef}
                        type="text"
                        placeholder="Edit text..."
                        value={inputValue}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                        onKeyDown={(e) => e.key === "Enter" && handleInputBlur()}
                        style={{
                            position: "absolute",
                            left: textAreas.find((t) => t.id === editingId)?.x + "px",  // ✅ Set X position at cursor
                            top: textAreas.find((t) => t.id === editingId)?.y + "px",  // ✅ Set Y position at cursor
                            fontSize: "16px",
                            border: "1px solid black",
                            background: "white",
                            padding: "2px",
                            outline: "none",
                        }}
                    />
                )}
                {isSnapToGridChecked && (
                    <p>
                        X: {cursorPos.x}, Y: {cursorPos.y}
                    </p>
                )}
                

                {/* </div> */}
            </div>
            <div className="p-4">
      {/* {codeType === 'upc' && (
        <>
          <p className="mb-2 text-sm text-gray-600">UPC for: {url}</p>
          <Barcode value={upcCode} format="UPC" />
        </>
      )}

      {codeType === 'barcode' && (
        <>
          <p className="mb-2 text-sm text-gray-600">Barcode for: {url}</p>
          <Barcode value={url} format="CODE128" />
        </>
      )} */}
     <div className="p-4 space-y-4">{generateBarcodes()}</div>
    </div>
        </>
    )
}

export default Displaypannel